<div *ngIf="model">
    <div style="display: flex;justify-content: end; padding: 10px;">
        <button (click)="addDatiPagamento(); notifyChange();" style="margin-right: 10px;">{{'general.add' | translate}}</button>
        <button (click)="refreshTotali.emit();" placement="left" [ngbTooltip]="'invoices.edit.paymentData.other.tooltip.loadTot' | translate">{{'invoices.edit.paymentData.btn.recalculateAmount' | translate}}</button>
    </div>
   
    <div *ngIf="model.FatturaElettronicaBody.DatiPagamento">
        <div class="container-fluid">
            <div class="row border-top pt-2" *ngFor="let val of model.FatturaElettronicaBody.DatiPagamento; let i = index;">
                <div class="col-12 text-right">
                    <span class="roboSubTitle float-left">{{'invoices.edit.serviceData.other.nLine' | translate}} {{i+1}}</span>    
                    <button type="button" style="margin-right: 5px;" class="btn btn-sm" (click)="modificaDatoPagamento(val);">
                        <i class="bi bi-pencil-fill"></i>
                    </button>
                    <button type="button" class="btn btn-danger btn-sm" (click)="deleteDatoPagamento(i); notifyChange();"><img src="assets/icone_varie/cestino.svg"></button>
                </div>
                <div class="col-12 col-md-4 col-lg-3 form-group">
                    <label>{{'invoices.edit.paymentData.other.condition' | translate}}</label>
                    <app-select class="selectDm7" 
                            [valClass]="val.CondizioniPagamento != '' ? 'borderGreen' : 'borderRed'"
                            [options]="configProps!.list.listCondizioniPagamento"
                            [key]="'val'" [value]="'label'"
                            [placeholder]="'placeholder.select' | translate" [addNull]="false" [selectedKey]="val.CondizioniPagamento"
                            (change)="val.CondizioniPagamento= $event.key; notifyChange();"></app-select>
                </div>
                <div class="col-12 col-md-8 col-lg-6 form-group">
                    <label>{{'invoices.edit.paymentData.other.beneficiary' | translate}}</label>
                    <input type="text" class="form-control" [placeholder]="'invoices.edit.paymentData.other.beneficiary' | translate" aria-describedby="basic-addon1" [(ngModel)]="val.DettaglioPagamento.Beneficiario"  (ngModelChange)="notifyChange()">
                </div>
                <div class="col-12 col-md-4 col-lg-3 form-group">
                    <label>{{'invoices.edit.paymentData.other.mode' | translate}}</label>
                    <app-select class="selectDm7" 
                            [options]="configProps!.list.listModalitaPagamento"
                            [key]="'val'" [value]="'label'"
                            [placeholder]="'placeholder.select' | translate" [addNull]="false" [selectedKey]="val.DettaglioPagamento.ModalitaPagamento"
                            (change)="val.DettaglioPagamento.ModalitaPagamento= $event.key; checkIbanMP05(i); notifyChange();"></app-select>
                </div>
                <div class="col-12 col-md-8 col-lg-4 form-group">
                    <label>{{'invoices.edit.paymentData.other.iban' | translate}}</label>
                    <div class="input-group" style="flex: 1">
                        <input type="text" class="form-control" [placeholder]="'invoices.edit.paymentData.other.iban' | translate" aria-describedby="basic-addon1" [(ngModel)]="val.DettaglioPagamento.IBAN"  (ngModelChange)="notifyChange()">
                        <span  class="input-group-text" id="basic-addon1" (click)="cercaIbanAggiuntivi(i)"><i class="bi bi-search"></i> </span>
                    </div>

                </div>
                <div class="col-12 col-md-4 col-lg-4 form-group">
                    <label>{{'invoices.edit.paymentData.other.ExpirationDate' | translate}}</label>
                    <div class="input-group dm7DatePicker">
                        <input class="form-control" placeholder="gg-mm-aaaa"
                                name="d2" #c2="ngModel" [(ngModel)]="val.DettaglioPagamento.DataScadenzaPagamento"
                                (ngModelChange)="notifyChange()" readonly
                                ngbDatepicker #d2="ngbDatepicker">
                        <button class="btn btn-outline-secondary calendar" style="height: 33px !important; border-radius: 0 !important;"
                            (click)="val.DettaglioPagamento.DataScadenzaPagamento = '';notifyChange();" type="button">
                            <i class="bi bi-x-lg"></i>
                        </button>
                        <button class="btn btn-outline-secondary calendar" (click)="d2.toggle()" type="button">
                            <i class="bi bi-calendar-week"></i>
                        </button>
                    </div>
                </div>
                <div class="col-12 col-md-4 col-lg-4 form-group">
                    <label>{{'invoices.edit.paymentData.other.amountPayment' | translate}}</label>
                    <input type="text" [ngClass]="[val.DettaglioPagamento.ImportoPagamento != '' ? 'borderGreen' : 'borderRed']"  class="form-control" [placeholder]="'invoices.edit.paymentData.other.amountPayment' | translate" aria-describedby="basic-addon1" [(ngModel)]="val.DettaglioPagamento.ImportoPagamento"  (ngModelChange)="notifyChange()">
                </div>
            </div>
        </div>
    </div>

</div>
